import React from "react";
import ApprovalScope from "./ApprovalScope";
import Footer from "../components/Footer";

// ICONS
import {
  FaProjectDiagram,
  FaUsersCog,
  FaClipboardList,
  FaHardHat,
  FaTasks,
  FaDraftingCompass,
  FaCheckCircle
} from "react-icons/fa";

import hero1 from "../image/pmc-img.png";
import hero4 from "../image/pmc-img.png";

const pmcData = [
  {
    id: "01",
    icon: <FaProjectDiagram />,
    title: "Consultant Coordination",
    desc: "Coordination between architect, structural consultants, and service consultants to ensure smooth project execution.",
  },
  {
    id: "02",
    icon: <FaUsersCog />,
    title: "Contractor Selection & Scope Clarification",
    desc: "Guidance in contractor selection, scope understanding, and execution planning for efficient project management.",
  },
  {
    id: "03",
    icon: <FaClipboardList />,
    title: "Construction Planning & Scheduling",
    desc: "Preparation of construction schedules, activity planning, and workflow coordination for systematic execution.",
  },
  {
    id: "04",
    icon: <FaHardHat />,
    title: "Site Supervision & Quality Checks",
    desc: "Regular site supervision and quality monitoring to maintain workmanship standards during construction.",
  },
  {
    id: "05",
    icon: <FaTasks />,
    title: "Progress Monitoring & Issue Resolution",
    desc: "Tracking construction progress, resolving coordination issues, and ensuring smooth execution on site.",
  },
  {
    id: "06",
    icon: <FaDraftingCompass />,
    title: "Execution as Per Approved Drawings",
    desc: "Ensuring all work is carried out according to approved architectural, structural, and service drawings.",
  },
  {
    id: "07",
    icon: <FaCheckCircle />,
    title: "Support Until Project Completion",
    desc: "End-to-end project management support from planning stage to final construction completion.",
  },
];

export default function PMC({ openContactModal, showCTA }) {
  return (
    <div>

      <ApprovalScope
        heroTitle={`Project Management Consultancy`}

        heroSubtitle="End-to-end construction support for smooth and efficient project execution."

        heroImg={hero1}
        heroBg={hero4}

        sectionTitle="PMC Services"

        topText="We provide complete project management consultancy support to streamline construction execution, coordinate consultants and contractors, maintain quality standards, and ensure timely progress throughout the project lifecycle."

        heading="Detailed PMC Scope"

        data={pmcData}

        ctaTitle="The Dwellora PMC Approach"

        ctaDesc="Our PMC services bridge the gap between planning and execution through continuous coordination, quality monitoring, and practical site management support. This ensures smoother workflows, reduced delays, and better construction outcomes."

        ctaBtn="Let’s Consult"

        openContactModal={openContactModal}
      />

      <Footer
        openContactModal={openContactModal}
        showCTA={showCTA}
      />

    </div>
  );
}